import { AppContext } from "App";
import { NavigationLink } from "components/base/base";
import Page from "components/base/Page";
import { useContext } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { PRICE_EDITOR, PRICE_VIEWER } from "utils/permissions";
import Trends from "./analysis/Trends";
import ExchangeRates from "./exchangeRates";
import Material from "./material";
import Products from "./products";
import Suppliers from "./suppliers";
import UpdateHistory from "./updateHistory";

function PricePages() {
  const { hasPermission } = useContext(AppContext);
  const hasEditorPermission = hasPermission(PRICE_EDITOR);
  const hasViewerPermission = hasPermission(PRICE_VIEWER);
  const hasAnyPermission = hasEditorPermission || hasViewerPermission;

  if (!hasAnyPermission)
    return (
      <div className="flex flex-1 items-center justify-center font-bold text-2xl h-screen text-gray-600">
        Not Allowed.
      </div>
    );

  const LeftButtonsView = () => {
    if (hasEditorPermission) {
      return (
        <div className="flex space-x-4">
          <NavigationLink to="/price/products/AB" title="Products(AB)" />
          <NavigationLink to="/price/products/LTD" title="Products(LTD)" />
          <NavigationLink to="/price/suppliers" title="Suppliers" />
          <NavigationLink to="/price/update-history" title="Update History" />
        </div>
      );
    } else if (hasViewerPermission) {
      return <NavigationLink to="/price/products/AB" title="Products(AB)" />;
    }
  };

  const routes = () => {
    if (hasEditorPermission) {
      return (
        <Routes>
          <Route path="products/*" element={<Products />} />
          <Route path="materials/*" element={<Material />} />
          <Route path="exchange-rates/*" element={<ExchangeRates />} />
          <Route path="suppliers/*" element={<Suppliers />} />
          <Route path="update-history" element={<UpdateHistory />} />
          <Route path="analysis">
            <Route path="trends" element={<Trends />} />
          </Route>
          <Route path="*" element={<Navigate to="products/AB" />} />
        </Routes>
      );
    } else if (hasViewerPermission) {
      return (
        <Routes>
          <Route path="products/*" element={<Products />} />
          <Route path="*" element={<Navigate to="products/AB" />} />
        </Routes>
      );
    }
  };

  return (
    <Page
      leftButtons={<LeftButtonsView />}
      rightButtons={
        hasEditorPermission ? (
          <div className="flex space-x-4">
            <NavigationLink to="/price/materials" title="Raw Materials" />
            <NavigationLink to="/price/exchange-rates" title="Exchange Rates" />
            <NavigationLink to="/price/analysis/trends" title="Trends" />
          </div>
        ) : null
      }
      className="h-screen"
    >
      {routes()}
    </Page>
  );
}

export default PricePages;
